/**
 * Lazy eruda lifecycle. The promise guard makes ensure/destroy safe against
 * StrictMode double-effects and rapid mode switching.
 */
import { defaultDevWidgetPos } from './safe-area'

let loader: Promise<typeof import('eruda').default> | null = null

export function ensureEruda(): Promise<typeof import('eruda').default> {
	loader ??= import('eruda').then(({ default: eruda }) => {
		eruda.init()
		// Anchor below Telegram's fullscreen controls (shared with the icon).
		eruda.position(defaultDevWidgetPos())
		return eruda
	})
	return loader
}

export function destroyEruda(): void {
	// If the import is still in flight, destroy right after it initializes.
	void loader?.then((eruda) => eruda.destroy())
	loader = null
}
